import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppService {

  constructor(
    private http: HttpClient
  ) {
  }

  currentInstitution$: BehaviorSubject<any> = new BehaviorSubject(false);

  apps = [
    { name: 'ExamMonitor', key: 'exam-monitor'},
    { name: 'ExamID', key: 'exam-id'},
    // { name: 'ExamNow', key: 'exam-now'}
  ]

  find(type){
    return this.apps.filter( app => app.key === type );
  }

  getApps(): Promise<any> {
    return new Promise( (resolve) => {
      resolve(this.apps)
    })
  }

}
